/**
 * dashboard/classes/new.tsx — Tutor opens a new class.
 *
 * Lives at `/dashboard/classes/new`. Auth-gated to approved tutors; admin /
 * student / unauthenticated visitors get redirected per role.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { PageHeader } from '../../../components/ui/PageHeader.js';
import { CreateClassForm } from '../../../components/tutor/CreateClassForm.js';
import { freshSessionQuery, type SessionPrincipal } from '../../../lib/api/queries.js';

export const Route = createFileRoute('/dashboard/classes/new')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role === 'admin') {
      throw redirect({ to: '/admin' });
    }
    if (user.role !== 'tutor' || !user.isApprovedTutor) {
      throw redirect({ to: '/me' });
    }
    return null;
  },
  component: NewClassPage,
});

function NewClassPage(): ReactNode {
  return (
    <main className="page-shell">
      <PageHeader
        eyebrow="Kelas baru"
        title="Buka kelas baru"
        description="Isi detail kelas. Kamu bisa menambahkan siswa dan membuka materi setelah kelas terbuat."
      />
      <section className="section surface">
        <CreateClassForm />
      </section>
    </main>
  );
}
